module.exports = __webpack_public_path__ + "public/Icons/cancelIcon.svg?6f6f4023";